import React from 'react';
import styled from 'styled-components';

const NumberWrapper = styled.div`
  position: absolute;
  bottom: ${props => props.theme.spacing.containerPadding};
  right: ${props => props.theme.spacing.containerPadding};
  font-family: "etna", serif;
  font-weight: 600;
  font-size: clamp(1rem, 2vw, 1.5rem);
  color: ${props => props.$light ? props.theme.colors.charcoal : props.theme.colors.bone};
  opacity: 0.5;
  z-index: 2;
  user-select: none;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    display: none;
  }
`;

const SectionNumber = ({ number, light = false }) => {
  return <NumberWrapper $light={light}>/{number.toString().padStart(2, '0')}</NumberWrapper>;
};

export default SectionNumber;
